import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LuPresentation, LuPlayCircle, LuArrowRight, LuX } from "react-icons/lu";
import * as styled from "./PlatformNews.styled";
import { fetchAllPlatformLessons } from "../../../helpers/materials/platformLessons";
import { OPEN_EVENT } from "../../PlatformLessonsTour/PlatformLessonsTour";

// Банер-оголошення вгорі головної вчителя (англійська). Можна сховати — запамʼятовуємо на пристрої.
// Нове оголошення → нова версія ключа, щоб банер побачили й ті, хто сховав попередній
const hiddenKey = (teacherId) => `platformNewsHidden:v2:${teacherId}`;

function PlatformNews({ teacher }) {
  const navigate = useNavigate();
  const [lessonsCount, setLessonsCount] = useState(0);
  const [hidden, setHidden] = useState(() => {
    try {
      return window.localStorage.getItem(hiddenKey(teacher?._id)) === "1";
    } catch (error) {
      return false;
    }
  });

  useEffect(() => {
    if (teacher?.accessType !== "en" || hidden) return;
    fetchAllPlatformLessons()
      .then((lessons) => setLessonsCount(lessons.length))
      .catch(() => {});
  }, [teacher?.accessType, hidden]);

  if (hidden || !lessonsCount) return null;

  const hide = () => {
    try {
      window.localStorage.setItem(hiddenKey(teacher._id), "1");
    } catch (error) {}
    setHidden(true);
  };

  return (
    <styled.Banner>
      <styled.Close type="button" aria-label="Сховати" onClick={hide}>
        <LuX size={18} />
      </styled.Close>
      <styled.Icon>
        <LuPresentation size={30} />
      </styled.Icon>
      <styled.Text>
        <styled.Badge>Важливо</styled.Badge>
        <h3>Дорослі — тепер на уроках платформи</h3>
        <ul>
          <li>
            <b>Пробний з дорослим</b> — лише «Пробний урок» з уроків платформи. Пробні з Canva для дорослих прибрали.
          </li>
          <li>
            <b>Вже є Beginner, Elementary і Pre-Intermediate.</b> Нові учні-дорослі займаються лише за матеріалами
            платформи.
          </li>
          <li>
            <b>Поточних учнів</b> можна перевести на нові матеріали («Мої учні» → «Матеріали») або залишити на Canva —
            як вам зручніше.
          </li>
        </ul>
      </styled.Text>
      <styled.Actions>
        <styled.Light type="button" onClick={() => window.dispatchEvent(new Event(OPEN_EVENT))}>
          <LuPlayCircle size={18} /> Як це працює
        </styled.Light>
        <styled.Accent
          type="button"
          onClick={() => {
            try {
              window.localStorage.setItem("materialsMode", "platform");
            } catch (error) {}
            navigate("/teacher/materials");
          }}
        >
          Відкрити уроки <LuArrowRight size={18} />
        </styled.Accent>
      </styled.Actions>
    </styled.Banner>
  );
}

export default PlatformNews;
